module.exports = __webpack_public_path__ + "static/media/intel.01e22a52.pdf";